import { render, staticRenderFns } from "./PhoneSimManageList.vue?vue&type=template&id=9f1facf0&scoped=true&"
import script from "./PhoneSimManageList.vue?vue&type=script&lang=js&"
export * from "./PhoneSimManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1facf0",
  null
  
)

export default component.exports